module.exports = __webpack_public_path__ + "static/mile-high-boys-club.bdf4ce2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mile-high-boys-club.png
// module id = 1700
// module chunks = 173894859265406